const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_43903435420ad1c781af29144b1c1084_e16a285f.jpg"
          alt="Duendecillos Let's Play - Centro de educación infantil"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight"
              style={{ textShadow: '0 4px 20px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.3)' }}>
            Escuela Infantil en Madrid donde tu hijo crece feliz, seguro y acompañado
          </h1>
          
          {/* Translucent Card for Subtitle and CTAs */}
          <div className="backdrop-blur-md bg-[#4A7C59]/70 rounded-3xl px-8 py-8 sm:px-12 sm:py-10 shadow-2xl max-w-3xl mx-auto">
            <p className="text-lg sm:text-xl text-white mb-8 leading-relaxed font-medium">
              Educación infantil 0-3 años en San Blas. Cuidamos, educamos y acompañamos con cariño, dedicación y profesionalidad.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <button
                onClick={scrollToContact}
                className="bg-[#FF7F6E] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#ff6b58] transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Solicitar visita
              </button>
              <button
                onClick={scrollToContact}
                className="bg-white/95 text-gray-800 px-8 py-4 rounded-full font-semibold text-lg hover:bg-white transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                Contactar ahora
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-gray-700"></i>
      </div>
    </section>
  );
};

export default Hero;
